// extracted by mini-css-extract-plugin
export default {"homepage__section":"style_homepage__section__ZX-l3","homepage__texts":"style_homepage__texts__zqz2v"};